import React from "react";

const NotFound = () => {
	return (
		<main className="container loading notFound">
			<p>
				404 <span>|</span> Page Not Found
			</p>
		</main>
	);
};

export default NotFound;
